<template>
    <b-modal
      size="md"
      :hideFooter="true"
      :hideHeader="true"
      centered
      id="selectTestRole"
    >
      <template slot="default">
        <b-row>
          <b-col class="float-left">
            <em class="fas fa-lg fa-exclamation"></em>
          </b-col>
        </b-row>
        <b-container class="confirm-modal-cnt">
          <b-row class="text-center mt-2">
            <h6 class="confirm-modal-text text-center w-100">
              Для кого Вы хотите создать тест?
            </h6>
          </b-row>
          <b-row class="text-center ml-5 mt-3">
              <b-form-radio class="mb-3" v-model="selected" value="0">Для всех</b-form-radio>
          </b-row>
          <b-row class="text-center ml-5 mb-5">
              <b-form-radio v-model="selected" value="1">Для моей организации</b-form-radio>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-button @click="createTest" class="confirm-modal-btn" variant="primary">
                Создать тест
              </b-button>
            </b-col>
            <b-col sm="12" md="6">
              <b-button @click="closeModal" class="confirm-modal-btn" variant="outline-primary">
                Отмена
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
</template>

<script>

import { mapActions } from 'vuex'
import TestAPI from '@/api/test'
import RouteMixin from '@/components/helpers/mixins/route-mixin'


export default {
  name: 'DeleteTestModal',
  mixins: [RouteMixin],
  data() {
    return {
      selected: ''
    }
  },
  methods: {
    ...mapActions({
      updateTestCreationMode: 'test/updateTestCreationMode',
      fetchContentForNewTest: 'test/fetchContentForNewTest',
      fetchCourseContent: 'education/fetchCourseContent'
    }),
    closeModal() {
      this.$bvModal.hide('selectTestRole')
    },
    createTest() {
      TestAPI.makeNewTest(this.$route.params.courseBookId, Boolean(Number(this.selected)))
        .then((response) => {
          this.fetchCourseContent({ id: this.$route.params.courseBookId }).then(() => {
            // переходим на страницу с созданным тестом
            this.closeModal()
            this.$router.push(`${this.$_getCourseRoutePrefix(this.$route.path)}${
              this.$route.params.courseBookId}/test/${
              response.data.id}`)
          })
        })
        .catch((ex) => {
        })
    }
  }
}
</script>

<style scoped lang="scss">

  .confirm-modal-btn {
    width: 100%;
  }

  .confirm-modal-text {
    text-align: center;
    margin-bottom: 20px;
  }

  .resetName {
    width: 100%;
    margin-bottom: 20px;
  }

</style>
